export const isRenderablePrimitive = (value) => {
    const t = typeof value;
    return value === null || value === undefined || t === 'string' || t === 'number' || t === 'boolean' || t === 'bigint';
};


